import { render, staticRenderFns } from "./CakeOrderDetail.vue?vue&type=template&id=674529fa&scoped=true"
import script from "./CakeOrderDetail.vue?vue&type=script&lang=js"
export * from "./CakeOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./CakeOrderDetail.vue?vue&type=style&index=0&id=674529fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674529fa",
  null
  
)

export default component.exports